import { create } from 'zustand';
import type { Notification } from '@/types/database.types';

interface NotificationState {
  notifications: Notification[];
  unreadCount: number;
  isLoading: boolean;
  setNotifications: (notifications: Notification[]) => void;
  addNotification: (notification: Notification) => void;
  markAsRead: (id: string) => void;
  markAllAsRead: () => void;
  setLoading: (loading: boolean) => void;
  clear: () => void;
}

export const useNotificationStore = create<NotificationState>((set, get) => ({
  notifications: [],
  unreadCount: 0,
  isLoading: true,
  setNotifications: (notifications) =>
    set({
      notifications,
      unreadCount: notifications.filter((n) => !n.is_read).length,
      isLoading: false,
    }),
  addNotification: (notification) => {
    const current = get().notifications;
    const updated = [notification, ...current];
    set({
      notifications: updated,
      unreadCount: updated.filter((n) => !n.is_read).length,
    });
  },
  markAsRead: (id) => {
    const updated = get().notifications.map((n) =>
      n.id === id ? { ...n, is_read: true } : n,
    );
    set({
      notifications: updated,
      unreadCount: updated.filter((n) => !n.is_read).length,
    });
  },
  markAllAsRead: () => {
    const updated = get().notifications.map((n) => ({ ...n, is_read: true }));
    set({ notifications: updated, unreadCount: 0 });
  },
  setLoading: (isLoading) => set({ isLoading }),
  clear: () => set({ notifications: [], unreadCount: 0, isLoading: false }),
}));
